module.exports = __webpack_public_path__ + "media/assets/images/logos/ncino_mortgage_logo_dark-caae0286985c0a16bddf6a1bc5d2b5ff.svg";